import React from 'react';
import Box from '@mui/material/Box';

const GridViewContainer = ({ children, spacing = 2,  }) => {


  return (
    <Box sx={{ width:"100%",justifyContent:{xs:"flex-start",md:"space-between"}}} display="flex" flexWrap="wrap">
      {children}
    </Box>
  );
};

export default GridViewContainer;